"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProductFullName = exports.getDailyPercentageChangeClassModifier = exports.getBalanceWithProductSymbol = exports.getAvailableProductBalance = void 0;
var _numberFormatter = require("./numberFormatter");
var getBalanceWithProductSymbol = exports.getBalanceWithProductSymbol = function getBalanceWithProductSymbol(productSymbol, productBalance) {
  var applyToUSDOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (productSymbol === 'USD') {
    return "$".concat(productBalance);
  } else {
    if (applyToUSDOnly) {
      return "".concat(productBalance);
    } else {
      return "".concat(productBalance, " ").concat(productSymbol);
    }
  }
};
var getProductFullName = exports.getProductFullName = function getProductFullName(product) {
  return product ? product.ProductFullName : '';
};
var getAvailableProductBalance = exports.getAvailableProductBalance = function getAvailableProductBalance(product) {
  var negativeIsNaN = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return product && product.AvailableBalance ? (0, _numberFormatter.parseNumberToLocale)(product.AvailableBalance, undefined, negativeIsNaN) : '';
};
var getDailyPercentageChangeClassModifier = exports.getDailyPercentageChangeClassModifier = function getDailyPercentageChangeClassModifier(change) {
  if (change < 0) {
    return '24h-negative';
  } else if (change > 0) {
    return '24h-positive';
  } else {
    return '';
  }
};